<app-loading *ngIf="contentReady"></app-loading>
<div>
  <div class="row p-0 gx-0">
    <div class="col-12 col-sm-12 main-content ">
      <div class="container-fluid mb-12 ">
        <div>



          <button routerLink="/Profile" class="first-btn btn btn-primary">
            {{ "my profile" | translate }}
          </button>
          @if(isAdmin) {
          <button routerLink="/Resigter" class="first-btn  btn btn-primary">
            {{ "add User" | translate }}
          </button>
          }

          <div class="card" *ngFor="let element of this.allData; index as i;">
             @if(isAdmin) {
              <div class="dropdown floting">
                 
              <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fa-solid fa-ellipsis-vertical" style="font-size: larger;"></i>
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">

                <li><a class="dropdown-item" (click)='showpassword(element.read_password)'>{{ "Show Password" |
                    translate }} </a></li>

                <li><a class="dropdown-item" (click)='edituser(element)'>
                    {{ "Edit" | translate }} </a></li>
                <li><a class="dropdown-item" (click)='deleteuser(element.id)'>{{ "Delete" | translate }}</a></li>


              </ul>
            </div>
            }
            <div class="card-body">
              <div class="avatar">
                <img alt="" [src]="changeUrl(element.photo_url)">
              </div>

              <p class="card-text">


                <i class="fa-solid fa-user"></i>{{ "username" | translate }}:{{element.username}}
              </p>
              <p class="card-text">


                <i class="fa-solid fa-user-tie"></i>
                <span [ngSwitch]="element.type">
                  {{ "account type" | translate }}:
                  <span *ngSwitchDefault>{{ "admin" | translate }}</span>
                  <span *ngSwitchCase="'6'">{{ "subadmin" | translate }}</span>
                  <span *ngSwitchCase="'7'">{{ "employee" | translate }}</span>

                </span>
              </p>
        <p class="card-text">


                <i class="fa-solid fa-user-tie"></i>
                <span [ngSwitch]="element.has_access_to_phone_numbers">
                  بيشوف الارقام :
                  <span *ngSwitchCase="1">اه </span>
                  <span *ngSwitchCase="0">لا </span>

                </span>
         
              </p>
              <p class="card-text"><i class="fa-solid fa-phone"></i>{{ "phone" | translate }}:{{element.phone}}</p>
              <p class="card-text"><i class="fa-solid fa-image-portrait"></i> {{ "first_name" | translate }}:
                {{element.first_name}}</p>
              <p class="card-text"><i class="fa-solid fa-signature"></i> {{ "last_name" | translate
                }}:{{element.last_name}}</p>
            </div>



            <div class="card-body">
              <div class="row">

                <div class="col-4">
                  <button *ngIf="element.instagram_link != null" class="card-link btn btn-primary insta"
                    (click)='go(element.instagram_link)'>

                    <i class="fa-brands fa-instagram"></i>

                  </button>

                </div>
                <div class="col-4">
                  <button class="card-link btn btn-primary face" *ngIf="element.facebook_link != null"
                    (click)='go(element.facebook_link)'>

                    <i class="fa-brands fa-facebook-f"></i>

                  </button>
                </div>
                <div class="col-4">
                  <button class="card-link btn btn-primary tiktok" *ngIf="element.tiktok_link != null"
                    (click)='go(element.tiktok_link)'>

                    <i class="fa-brands fa-tiktok"></i>

                  </button>
                </div>
              </div>




            </div>
          </div>
        </div>
      </div>
    </div>
  </div>